import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TrialSignupComponent } from './signup/trial-signup.component';
import { TrialExpiredComponent } from './expired/trial-expired.component';

@NgModule({
  declarations: [TrialSignupComponent, TrialExpiredComponent],
  imports: [CommonModule, FormsModule, RouterModule, HttpClientModule],
})
export class TrialModule {}
